export const removeArrayDuplicates = <T>(arr: T[]): T[] => [...new Set(arr)];

// Gets an array of objects and a name of a property on those objects.
// Returns true if each object has a unique value on that property
// eslint-disable-next-line @typescript-eslint/ban-types
export function isCollectionDistinctByProperty<Obj extends object>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  collection: Obj[] | Record<keyof any, Obj>,
  property: keyof Obj
): boolean {
  const values = Object.values(collection);
  const valuesForGivenProperty = values.map((obj) => obj[property]);
  const uniqueValuesForProperty = removeArrayDuplicates(valuesForGivenProperty);
  return uniqueValuesForProperty.length === values.length;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isArraySubset = <T extends any>(
  potentialSuperset: T[],
  potentialSubset: T[]
) => potentialSubset.every((el) => potentialSuperset.includes(el));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const doArraysHaveCommonElement = <T extends any>(a: T[], b: T[]) =>
  a.some((el) => b.includes(el));

export function removeEmptyElements<TValue>(
  value: TValue | null | undefined
): value is TValue {
  return value !== null && value !== undefined;
}
